package fr.manyverse.app.presentation.components.onboarding

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.anonymous_sign_in_continue
import manyverse.shared.generated.resources.anonymous_sign_in_warning_message
import manyverse.shared.generated.resources.anonymous_sign_in_warning_title
import manyverse.shared.generated.resources.cancel
import org.jetbrains.compose.resources.stringResource

@Composable
fun AnonymousSignInWarningDialog(
    onConfirm: () -> Unit,
    onDismiss: () -> Unit
) {
    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text(stringResource(Res.string.anonymous_sign_in_warning_title)) },
        text = { Text(stringResource(Res.string.anonymous_sign_in_warning_message)) },
        confirmButton = {
            Button(onClick = onConfirm) {
                Text(stringResource(Res.string.anonymous_sign_in_continue))
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text(stringResource(Res.string.cancel))
            }
        }
    )
}
